export const menuData: any[] = [
    {
        "title": "Home",
        "icon": {
            "name": "home-outline"
        },
        "url": "/home",
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    },
    {
        "title": "Contenidos",
        "icon": {
            "src": "/assets/icons/contenido.svg"
        },
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ],
        "items": [
            {
                "title": "Todos",
                "icon": {
                    "name": "list-outline"
                },
                "url": "/multimedia",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Algoritmos",
                "icon": {
                    "src": "/assets/icons/esquema.svg"
                },
                "url": "/multimedia/posts/calculators-and-algorithms",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Inmunidad",
                "icon": {
                    "src": "/assets/icons/inmunidad.svg"
                },
                "url": "/multimedia/posts/immunity",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Flashcards",
                "icon": {
                    "src": "/assets/icons/flashcards.svg"
                },
                "url": "/multimedia/posts/flashcards",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Cursos",
                "icon": {
                    "src": "/assets/icons/cursos_congresos.svg"
                },
                "url": "/multimedia/courses-and-congresses",
                "collapsed": false,
                "user": [
                    "representante-medico",
                    "medico"
                ]
            },
            {
                "title": "Artículos",
                "icon": {
                    "src": "/assets/icons/articulos-text.svg"
                },
                "url": "/multimedia/posts/articles",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Boletines",
                "icon": {
                    "name": "newspaper-outline"
                },
                "url": "/multimedia/posts/newsletters-and-news",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "I. Farmacéutica",
                "icon": {
                    "src": "/assets/icons/farma-posts.svg"
                },
                "url": "/multimedia/posts/pharmaceutical-industry",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Sesiones virtuales",
                "icon": {
                    "name": "tv-outline"
                },
                "url": "/multimedia/videos/webinars",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Podcast",
                "icon": {
                    "name": "radio-outline"
                },
                "url": "/podcast",
                "highlight": "podcast-playing",
                "user": [
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Entrevistas",
                "icon": {
                    "src": "/assets/icons/entrevista.svg"
                },
                "url": "/multimedia/videos/interviews",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Notimed",
                "icon": {
                    "src": "/assets/icons/notimed_solo.svg"
                },
                "url": "/multimedia/videos/notimed",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Foro Médico",
                "icon": {
                    "name": "chatbubbles-outline"
                },
                "url": "/multimedia/foro",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion"
                ]
            }
        ]
    },
    {
        "title": "Sesiones virtuales",
        "icon": {
            "name": "tv-outline"
        },
        "url": "/multimedia/videos/webinars",
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    },
    {
        "title": "Notimed",
        "icon": {
            "src": "/assets/icons/notimed_solo.svg"
        },
        "url": "/multimedia/videos/notimed",
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    },
    {
        "title": "Artículos",
        "icon": {
            "src": "/assets/icons/articulos-text.svg"
        },
        "url": "/multimedia/posts/articles",
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    },
    {
        "title": "Constancias",
        "highlight": "certificatesCount",
        "icon": {
            "name": "school-outline"
        },
        "url": "/certificates",
        "user": [
            "medico",
            "medico-en-formacion"
        ]
    },
    {
        "title": "Donaciones",
        "icon": {
            "name": "heart-outline"
        },
        "url": "/donations",
        "user": [
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    },
    {
        "title": "Podcast",
        "icon": {
            "name": "radio-outline"
        },
        "url": "/podcast",
        "highlight": "podcast-playing",
        "user": [
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    },
    {
        "title": "Chat",
        "icon": {
            "name": "chatbox-outline"
        },
        "url": "/chat-list",
        "highlight": "chatsCount",
        "user": [
            "medico",
            "representante-medico"
        ]
    },
    {
        "title": "Industria",
        "icon": {
            "src": "/assets/icons/medicine.svg"
        },
        "user": [
            "medico"
        ],
        "items": [
            {
                "title": "Empresas",
                "icon": {
                    "src": "/assets/icons/farma-empresas.svg"
                },
                "url": "/industry/companies",
                "user": [
                    "medico"
                ]
            },
            {
                "title": "Medicamentos",
                "icon": {
                    "src": "/assets/icons/farma-med.svg"
                },
                "url": "/industry/medicines",
                "user": [
                    "medico"
                ]
            },
            {
                "title": "Dispositivos",
                "icon": {
                    "src": "/assets/icons/farma-dis.svg"
                },
                "url": "/industry/devices",
                "user": [
                    "medico"
                ]
            },
            {
                "title": "Servicios",
                "icon": {
                    "name": "ribbon-outline"
                },
                "url": "/industry/services",
                "user": [
                    "medico"
                ]
            }
        ]
    },
    {
        "title": "Mis productos",
        "icon": {
            "src": "/assets/icons/medicine.svg"
        },
        "url": "/industry/my-products",
        "user": [
            "representante-medico"
        ]
    },
    {
        "title": "Red Conectimed",
        "icon": {
            "src": "/assets/icons/red_conectimed.svg"
        },
        "url": "/red-conectimed",
        "user": [
            "representante-medico",
            "medico"
        ]
    },
    {
        "title": "Acerca de Conectimed",
        "icon": {
            "name": "settings-outline"
        },
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ],
        "items": [
            {
                "title": "Preguntas Frecuentes",
                "icon": {
                    "name": "help-circle-outline"
                },
                "url": "/frequent-questions",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Términos y Condiciones",
                "icon": {
                    "name": "thumbs-up-outline"
                },
                "url": "/terms",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Aviso de Privacidad",
                "icon": {
                    "name": "lock-closed-outline"
                },
                "url": "/privacy",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Versión y permisos",
                "icon": {
                    "name": "information-circle-outline"
                },
                "url": "/about",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            },
            {
                "title": "Cancelar afiliación",
                "icon": {
                    "name": "person-remove-outline"
                },
                "url": "/delete-account",
                "user": [
                    "representante-medico",
                    "medico",
                    "medico-en-formacion",
                    "profesional-de-la-salud"
                ]
            }
        ]
    },
    {
        "title": "Favoritos",
        "icon": {
            "name": "star-outline"
        },
        "url": "/multimedia/posts/favorites",
        "user": [
            "representante-medico",
            "medico",
            "medico-en-formacion",
            "profesional-de-la-salud"
        ]
    }
];